export function startsWithHttpOrHttps(url: string): string | null {
  const pattern = /^(http|https):\/\//
  if (pattern.test(url)) {
    return url
  }

  return null
}

export function addDomainOnUrl(url: string | undefined | null): string | null {
  const domain = process.env.STRAPI_URL
  const pattern = /^https?:\/\//i

  if (!url || url === undefined) {
    return null
  }

  if (pattern.test(url)) {
    return url
  }

  return `${domain}${url}`
}

export function returnNullIfEmptyString(
  value: string | null | undefined,
): string | null {
  return (value && value.trim() === '') || value === undefined ? null : value
}

export function haversineDistance(
  coords1: [number, number],
  coords2: [number, number],
): number {
  const R = 6371
  const [lat1, lon1] = coords1
  const [lat2, lon2] = coords2

  const dLat: number = (lat2 - lat1) * (Math.PI / 180)
  const dLon: number = (lon2 - lon1) * (Math.PI / 180)

  const a: number =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) *
      Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2)

  const c: number = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const distance: number = R * c

  return distance * 1000
}

export function getDefaultActiveTab(location: {
  search: string
}): string | null {
  const searchParams = new URLSearchParams(location.search)
  const tab = searchParams?.get('tab')
  return tab
}
